/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Index_DescriptionInputs */

const en_meta_showcase_index_description = /** @type {(inputs: Meta_Showcase_Index_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A live hotel booking engine demo: real-time availability, AI concierge, operator dashboard and brand-native theming for independent hotels.`)
};

const lv_meta_showcase_index_description = /** @type {(inputs: Meta_Showcase_Index_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interaktīva rezervāciju sistēmas demonstrācija: reāllaika pieejamība, AI konsjeržs, operatora panelis un zīmolam pielāgota tēma viesnīcām un viesu namiem.`)
};

/**
* | output |
* | --- |
* | "A live hotel booking engine demo: real-time availability, AI concierge, operator dashboard and brand-native theming for independent hotels." |
*
* @param {Meta_Showcase_Index_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_index_description = /** @type {((inputs?: Meta_Showcase_Index_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Index_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_index_description(inputs)
	return en_meta_showcase_index_description(inputs)
});